import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';
import { FormOption } from '@core/navigation/store/state';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { MatIcon } from '@angular/material/icon';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'app-form-selector',
    templateUrl: './form-selector.component.html',
    styleUrls: ['./form-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatSelect,
        MatSelectTrigger,
        MatIcon,
        MatOption,
    ]
})
export class FormSelectorComponent {
  private _forms: FormOption[] = [];

  @Input() set forms(forms: FormOption[]) {
    this._forms = forms?.length ? forms : [];
    this.selectedFormId = this._forms.length ? this._forms[0].id : null;
    this.selectedFormName = this._forms.length ? this._forms[0].name : null;
  }

  readonly formSelected = output<string>();

  selectedFormId: string = null;
  selectedFormName: string = null;
  get forms(): FormOption[] {
    return this._forms;
  }

  onOptionSelected(formId: string) {
    if (formId !== this.selectedFormId) {
      this.selectedFormId = formId;
      this.selectedFormName = this._forms.find(x=>x.id == formId).name;
      this.formSelected.emit(this.selectedFormId);
    }
  }
}
